// İSG uzmanı portalı — kapı kodunu QR olarak çizen izole bileşen (S32 tasarım spec'i §9; cila
// turu `docs/reviews/S32c-gate-desk-polish.md` §6, sign-off eklentisi §13, marka rozeti
// rasterize güncellemesi — owner talebi 2026-08-17). Sembol + sessiz bölge + marka rozeti bu
// bileşenin sorumluluğudur — `GateStage.tsx` yalnız SUNAR, hiçbir renk/geometri kararı almaz.
//
// `qrcode` bu dilimin TEK yeni bağımlılığıdır (plan 2.4) ve YALNIZ ÜRETİM için (tarama YOK —
// `@zxing/*` bu dilimde GEREKMEZ). İçe aktarım BURADA, dinamik (`await import('qrcode')`) —
// diğer dokuz web-expert modülü bu paketin ağırlığını TAŞIMAZ (route-level code splitting
// yeterli değildir; `security` rotası zaten kendi chunk'ındadır ama `qrcode`'un KENDİSİ de
// yalnız bu bileşen monte olunca indirilir).
//
// **E3 — sessiz bölge (S32c §6.2, dosya değişikliğinden BAĞIMSIZ, pre-existing defekt).**
// Kütüphane `margin: 1` çizer (ISO/IEC 18004 4 modül ister); sembolün ETRAFI eskiden
// `GateStage.tsx`'in `bg-bg` sarmalıydı — açık temada zararsız (kum zaten AÇIK), koyu temada
// `#121418`'e YAKIN SİYAH, yani 1 modüllük beyaz sessiz bölge kod okuyucunun TAM aradığı
// mesafede KOYU bir komşuyla çevriliydi (en kötü ihtimal). Fix: `margin: 1` SEMBOL üzerinde
// KALIR (modül aralığı BOZULMAZ), sembol kendi **tema-BAĞIMSIZ** açık plakasının üzerine oturur
// (`p-6` ≈ 3.49 modül ek boşluk + kütüphanenin kendi 1 modülü = 4.49 — ISO'nun istediği 4'ün
// ÜSTÜNDE, S32c §13.4 düzeltmesi; `p-5` 3.91 modülde KALIYORDU, dokuz-yüzde eksikti).
//
// **§13.1/§13.2 — token'lı boyama, örnekleme (sampling) EMEKLİ.** Plaka rengi ARTIK çalışma
// anında canvas'tan OKUNMUYOR — `--color-qr-light`/`--color-qr-dark` (`tokens.css`, `@theme`
// bloğu, HİÇBİR koyu seçicide TEKRARLANMAZ — bu yokluk kendisi tema-bağımsızlık BEYANIDIR,
// `--color-inverse` ile AYNI desen) hem plakalara (`bg-qr-light` — bir CLASS, `style` DEĞİL) hem
// `QRCode.toCanvas` çağrısına `color: { dark, light }` olarak VERİLİR. Plaka ve sembol AYNI
// kaynaktan boyanır, YAPISAL olarak birbirinden KAYAMAZLAR. Token okuması boşsa `color` seçeneği
// HİÇ verilmez — kütüphane varsayımına düşülür (bugünkü değerlerle AYNI, görsel fark YOK).
//
// **Marka rozeti overlay'i (S32c §6.4, owner "kapla" tavsiyesini REDDETTİ).** ECC `'H'`,
// `QR_SIZE` 268'e çıktı (`GateStage.tsx`) — bugünkü `'M'`/240 modül aralığını KORUMAK için
// (aksi hâlde §6.1'in ölçtüğü ~%10 modül-aralığı düşüşü SESSİZCE gerçekleşirdi). Rozet ≥32px'in
// ALTINDAYSA overlay HİÇ render edilmez (kod DÜZ ve GEÇERLİ kalır — "hataya düşen overlay asla
// bir DELİĞE düşmez"). Kod ÖNCE boyanır, rozet SONRA biner.
//
// **Marka rozeti artık GERÇEK app icon rasteri (owner talebi, bu tur) — `GateMark` (inline SVG,
// çıplak grafit kare + baret) EMEKLİ, `packages/shared/src/assets/app-icon.png` (192×192, opak,
// `apps/mobile-supplier/assets/images/icon.png` onaylı 1024×1024 masterından küçültülmüş —
// gölgeli turuncu baret + "isgport" kelime işareti, grafit karo) onun YERİNE biner. En büyük
// güvenli kaplamada (aşağıdaki §6.4 arittmetiği) kelime işareti ~4–5px yüksekliğe düşer — METİN
// OLARAK OKUNMAZ, DOKU olarak okunur; bu KABUL EDİLMİŞTİR (owner), tavanı AŞARAK telafi
// EDİLMEZ. Rasterin kendisi 192×192 tam-kare bir kare boyar (köşe pikselleri örneklendi —
// alfa YOK, köşeler de grafit; OS'in kendi ikon maskesi gibi köşe YUVARLAMASI PNG'DE YOK), bu
// yüzden dış plakanın kare kalması (§13.4) artık yalnız bir tercih değil, gerçek bir eşleşme —
// iki keskin köşeli kare iç içe, yuvarlatma UYUŞMAZLIĞI YAPISAL olarak yok.
//
// **Rasterin yüklenmesi — SVG'den FARKLI bir yol, ayrı bir hata izolasyonu gerektirir.** Inline
// SVG eş zamanlı boyanır (ağ yok); bir `<img>` ASENKRONdur ve başarısız/YAVAŞ olabilir. Rozet
// `<img>`'i overlay geometrisi hesaplandıktan SONRA (kod zaten boyandıktan sonra) monte edilir,
// kendi `onLoad`'una kadar plakası `opacity-0` kalır (yüklenene dek sembolün ÜSTÜNDE HİÇBİR ŞEY
// GÖRÜNMEZ — QR'ın modülleri "boş bir ışık yaması" ile ÖRTÜLMEZ) ve hiç yüklenemezse SESSİZCE
// `opacity-0`'da KALIR — görsel olarak overlay hiç yokmuş gibi, yani DÜZ GEÇERLİ bir QR'a
// düşülür (§6.4'ün kuralı). Bu, canvas'a `drawImage` ile PİKSEL gömmekten BİLİNÇLİ olarak
// FARKLI bir tasarım: `<img>` ayrı bir DOM düğümüdür (§6.4 "DOM order suffices, no z-index"),
// yüklenmesi/başarısızlığı React state'i veya `qrcode` promise zincirini HİÇ TETİKLEMEZ —
// sembolün kendisi (canvas) VE dış sessiz-bölge plakası (`bg-qr-light` class'ı, §13.2) rozetin
// hâlinden YAPISAL olarak bağımsızdır, `try`/`catch` gerekmez.
//
// **§13.3 — dolu bir rozetin binarizer riski KABUL EDİLDİ, koşulu HÂLÂ geçerli.** Dolu koyu bir
// blok komşu modüllerin YEREL EŞİK değerini kaydırabilir (adaptif binarizer'lar) — S32c §10.1'in
// glare + off-axis satırları TAM BUNU test eder ve İSTEĞE BAĞLI DEĞİLDİR; bir tarama kabul turu
// bu bileşende bunları KIRPARSA rozetin asıl riski hiç ÖLÇÜLMEMİŞ olur.
//
// **Kaplama bütçesi — TAVANA çıkarıldı (owner talebi, bu tur).** Gölgeli bir raster çıplak bir
// vektörden daha fazla piksele ihtiyaç duyar; §6.4'ün 9×9 tavanı hâlâ geçerli ve önceden
// DOĞRULANMIŞ: 81 modül / 1369 (37×37, v5) = **%5.92** — §6.4'ün kendi tablosundaki "9×9 = %5.9"
// rakamıyla eşleşir, %30 ECC bütçesinin ALTINDA. Merkez berraklığı da §6.4'ün KENDİ metninde
// zaten var: "the symbol centre (18,18) is clear of [finders/timing/alignment], so a centred
// 7×7 **or 9×9** overlay touches only data and ECC modules" — yani 9×9'a çıkmak dokümanın
// SINIRINI AŞMAK değil, dokümanın ZATEN doğruladığı ikinci seçeneği KULLANMAK. Aşağıdaki
// `computeOverlayGeometry` bu yüzden 9×9'u ÖNCE dener, 32px tabanı KARŞILAMAZSA (yalnız daha
// küçük bir `QR_SIZE`'da olur) 7×7'ye GERİ ÇEKİLİR.
//
// **§6.5 tripwire — bu geometri 43 bayt'lık jeton (`OpaqueSecretToken`) İÇİNDİR.** Modül sayısı
// BURADA HER ZAMAN `QRCode.create()`'in GERÇEK sonucundan türetilir (v5=37 sabit KODLANMADI) —
// jeton formatı büyür de sembol v6'ya (41×41) sıçrarsa overlay geometrisi kendini YENİDEN
// hesaplar, ama S32c §6.4'ün "merkez fonksiyon desenlerinden UZAK" GEOMETRİK gerçeği
// versiyona ÖZGÜdür ve otomatik DOĞRULANMAZ — jeton formatı değişirse bu dosyayı yeniden OKU.

import { cn } from '@isgportal/shared';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
// `packages/shared`'ın `exports` haritası bu dosyayı AÇMAZ (yalnız `.`/`./core`/`./brand`/
// `./styles.css`) — repodaki TEK emsal (`tokens.css`'in her app `index.css`'inde ham GÖRECELİ
// yolla `@import` edilmesi) aynı deseni izler: paket sınırı JS/TS barrel'lar İÇİNDİR, bir
// kaynak varlığı doğrudan dosya yoluyla ÇEKMEK değil.
import appIconUrl from '../../../../../packages/shared/src/assets/app-icon.png';

export interface QrCodeCanvasProps {
  /** Kodlanacak opak jeton (§29.2 — QR içeriği). */
  value: string;
  /** Kare kenar uzunluğu (px) — tasarım spec'i §2: idle'da ≈360px, sahne varken küçülür. */
  size: number;
  /** Marka rozeti overlay'i (S32c §6.4) — yalnız AÇIKÇA istenince render edilir (izole
   *  bileşenin varsayılanı sade QR'dır); ECC bu bayrağa göre `'H'`/`'M'` seçilir. */
  withMark?: boolean;
  className?: string;
}

/** Kütüphaneye verilen sabit sessiz-bölge margin'i — DEĞİŞMEDİ (§6.2, modül aralığını bozmaz;
 *  ek sessiz bölge bunun yerine tema-bağımsız bir DOM plakasından gelir). */
const CANVAS_MARGIN_MODULES = 1;

/** S32c §6.4 — tavan kaplama bütçesi (modül), hiçbir zaman aşılmaz; raster rozet için ARTIK
 *  birincil hedef (owner talebi — daha fazla piksel, §6.4'ün kendi merkez-berraklığı notu
 *  9×9'u zaten kapsıyor). */
const OVERLAY_MODULES_CEILING = 9;
/** §6.4'ün önerdiği küçük bütçe — yalnız tavan 32px tabanını KARŞILAMAZSA geri çekilme. */
const OVERLAY_MODULES_RECOMMENDED = 7;
/** Rozetin etrafında ZORUNLU ≥1 modül açık pay (kaplama bütçesinin İÇİNDE). */
const OVERLAY_PADDING_MODULES = 1;
/** Bunun altında rozet bir "leke"dir — overlay hiç render edilmez (§6.4). */
const OVERLAY_MIN_MARK_PX = 32;

interface OverlayGeometry {
  platePx: number;
  markPx: number;
}

function computeOverlayGeometry(pxPerModule: number): OverlayGeometry | null {
  for (const overlayModules of [OVERLAY_MODULES_CEILING, OVERLAY_MODULES_RECOMMENDED]) {
    const markModules = overlayModules - OVERLAY_PADDING_MODULES * 2;
    const markPx = markModules * pxPerModule;
    if (markPx >= OVERLAY_MIN_MARK_PX) {
      return { platePx: Math.round(overlayModules * pxPerModule), markPx: Math.round(markPx) };
    }
  }
  return null;
}

/** §13.2 madde 3 — token'ı çalışma anında OKUR (yazma anında DEĞİL, kullanıcı `data-theme`'i
 *  değiştirmiş olabilir). Boş dönerse ('' — beklenmedik bir CSS yükleme sırası) çağıran
 *  `color` seçeneğini HİÇ vermez; kütüphane varsayımına düşülür. */
function readQrColorToken(name: '--color-qr-light' | '--color-qr-dark'): string {
  if (typeof document === 'undefined') {
    return '';
  }
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export function QrCodeCanvas({ value, size, withMark = false, className }: QrCodeCanvasProps) {
  const { t } = useTranslation();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [failed, setFailed] = useState(false);
  const [overlay, setOverlay] = useState<OverlayGeometry | null>(null);
  // Rozetin `<img>`'i yüklenene KADAR görünmez kalır (aşağıdaki render notuna bkz.) — geç/
  // başarısız bir yükleme QR'ı ya da sessiz-bölge plakasını HİÇBİR ŞEKİLDE etkileyemez, çünkü
  // ikisi de bu state'ten YAPISAL olarak bağımsızdır.
  const [markReady, setMarkReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setFailed(false);
    setOverlay(null);
    setMarkReady(false);
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    const errorCorrectionLevel = withMark ? ('H' as const) : ('M' as const);
    // Token'lı boyama (§13.2 madde 3) — plaka VE sembol AYNI kaynaktan (`tokens.css`) boyanır,
    // yapısal olarak birbirinden KAYAMAZLAR (§13.1, Q1/Q2/Q3'ün YAPISAL çözümü). İkisinden biri
    // boşsa `color` HİÇ verilmez — bugünkü değerlerle görsel fark YOK, bozulma MEVCUT
    // davranışa iner.
    const qrDark = readQrColorToken('--color-qr-dark');
    const qrLight = readQrColorToken('--color-qr-light');
    const color = qrDark && qrLight ? { dark: qrDark, light: qrLight } : undefined;
    import('qrcode')
      .then(async (QRCode) => {
        await QRCode.toCanvas(canvas, value, {
          width: size,
          margin: CANVAS_MARGIN_MODULES,
          errorCorrectionLevel,
          ...(color ? { color } : {}),
        });
        if (cancelled) {
          return;
        }
        // QR buradan sonra GEÇERLİDİR — overlay GEOMETRİSİ kendi try/catch'inde YALITILMIŞTIR
        // (§6.4 "failed overlay must degrade to a plain, valid QR — never to a hole"). Bu blok
        // patlarsa `failed` TETİKLENMEZ. Rozetin KENDİ yüklenmesi (raster `<img>`) burada HİÇ
        // BAŞLAMAZ — yalnız geometri hesaplanır, `<img>`'in `src`'si render'da atanınca tarayıcı
        // kendi ağ/decode yaşam döngüsünü yürütür, bu promise zincirinden TAMAMEN bağımsız.
        if (withMark) {
          try {
            const data = QRCode.create(value, { errorCorrectionLevel });
            const totalModules = data.modules.size + CANVAS_MARGIN_MODULES * 2;
            setOverlay(computeOverlayGeometry(size / totalModules));
          } catch {
            // sessizce yut — kod zaten boyandı, rozet yalnız bir süs.
          }
        }
      })
      .catch(() => {
        if (!cancelled) {
          setFailed(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [value, size, withMark]);

  // Kritik: `<canvas>` HER ZAMAN monte kalır, `failed` durumuna göre koşullu SÖKÜLMEZ (S32
  // review #3). Önceki sürüm başarısız olunca canvas'ı bir hata `<div>`'iyle DEĞİŞTİRİYORDU —
  // React ref'i unmount'ta otomatik `null`'a çeviriyor, sonraki jeton dönüşünde bu efekt
  // `setFailed(false)` çağırıp `canvasRef.current`'ı okuduğunda commit henüz gerçekleşmemiş
  // oluyordu, `if (!canvas) return` erken çıkıyordu ve `[value, size]` değişmediği için efekt bir
  // daha ASLA yeniden çalışmıyordu — sonuç: hatasız, sessiz, kalıcı boş kare. Node'u hiç
  // söküp-takmayarak (`canvasRef.current` bir kez bağlandıktan sonra hep dolu kalır) bu yarış
  // yapısal olarak imkânsız hâle gelir; hata durumu canvas'ın ÜSTÜNE bindirilen bir overlay'dir.
  return (
    // Tema-bağımsız açık plaka (§6.2/§13.2) — `bg-qr-light` bir CLASS'tır, `style` DEĞİL:
    // ilk kareden İTİBAREN doğru renktedir (eskisi gibi "boyanana kadar şeffaf" bir an YOK),
    // ve bir render'ın BAŞARISIZ olması bu rengi HİÇBİR ŞEKİLDE etkileyemez (Q1/Q2 YAPISAL
    // olarak imkânsız). `p-6` — ISO/IEC 18004'ün istediği 4 modüllük sessiz bölgeyi kütüphanenin
    // kendi 1 modülünün ÜSTÜNE ekler (§13.4: `p-5` 3.91 modülde kalıyordu, `p-6` 4.49'a çıkarır).
    <div className={cn('rounded-md bg-qr-light p-6', className)}>
      <div className="relative" style={{ width: size, height: size }}>
        <canvas
          ref={canvasRef}
          role="img"
          aria-label={t('security.gate.qrAriaLabel')}
          className="h-full w-full"
        />
        {overlay ? (
          <div
            aria-hidden="true"
            // §13.4 — dış plaka kare (yuvarlatma SINIFI YOK): raster kendisi tam-kare, keskin
            // köşeli boyandığından (dosya başı notu — PNG'de alfa/yuvarlatma YOK) iç içe iki
            // keskin köşeli kare arasında UYUŞMAZLIK yok. `opacity-0` → `opacity-100` GEÇİŞİ
            // `markReady`'ye bağlıdır — `<img>` yüklenene kadar bu kutu (plakası DAHİL)
            // görünmezdir, yani sembolün üstünde YARIM/boş bir yama HİÇBİR ZAMAN görünmez.
            className={cn(
              'pointer-events-none absolute top-1/2 left-1/2 flex items-center justify-center bg-qr-light transition-opacity',
              markReady ? 'opacity-100' : 'opacity-0',
            )}
            style={{
              width: overlay.platePx,
              height: overlay.platePx,
              transform: 'translate(-50%, -50%)',
            }}
          >
            <img
              src={appIconUrl}
              width={overlay.markPx}
              height={overlay.markPx}
              alt=""
              aria-hidden="true"
              onLoad={() => setMarkReady(true)}
              // `onError` açıkça YAZILDI (varsayılan zaten `markReady=false`'tur) — niyeti
              // BELGELEMEK için: başarısız bir yükleme kalıcı olarak `opacity-0`'da KALIR,
              // yani görsel olarak "overlay hiç yokmuş" gibi DÜZ GEÇERLİ bir QR'a düşülür.
              onError={() => setMarkReady(false)}
            />
          </div>
        ) : null}
        {failed ? (
          <div
            role="alert"
            className="absolute inset-0 flex items-center justify-center rounded-md border border-danger bg-danger-subtle p-4 text-center text-sm text-danger"
          >
            {t('security.gate.qrRenderError')}
          </div>
        ) : null}
      </div>
    </div>
  );
}
